// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import {
  Button,
  DatePicker,
  Upload,
  Message,
  MessageBox,
  Loading,
  Dialog,
  Select,
  Input,
  Option,
  Radio,
  Rate,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Tooltip,
  Progress,
  Table,
  TableColumn,
  Carousel,
  CarouselItem,
  Pagination
} from "element-ui";
import store from "./store.js";
import router from './router.js';
import axios from 'axios';
import $ from '@/assets/js/jqueryexport.js';
import '@/assets/js/jquery.word/jquery.wordexport.js';
import validateJS from "@/assets/js/validate.js";
import Tools from "./assets/js/Tools.js";
import urlMapper from "./assets/js/urlMapper";
import {devURL,validateLoginURL} from "./assets/js/urlMapper";

// css
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/default.css";
import "@/../static/css/scene01_old.css";
import "@/../static/css/matter-form.css";
import "@/../static/css/form.css";
import "./assets/css/guide.css";


Vue.use(Button);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Loading.directive);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(Rate);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tooltip);
Vue.use(Progress);
Vue.use(Table);
Vue.use(TableColumn);

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Pagination);


Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;

/*axios.defaults.timeout =  8000;*/
// axios.defaults.withCredentials = true;
Vue.prototype.$ = $;
Vue.prototype.$http = axios;
Vue.prototype.$timeout = 10000;


Vue.prototype.$urlMapper = urlMapper;

Vue.prototype.$validateJS = validateJS;

Vue.prototype.$Tools = Tools;

Vue.config.productionTip = false;

Vue.prototype.$devURL = devURL;
Vue.prototype.$validateLoginURL = validateLoginURL;
Vue.prototype.$domain = window.location.origin

String.prototype.startWith = function (str) {
    if (str == null || str== "" || this.length == 0 || str.length > this.length) {
        return false;
    }
    if (this.substr(0, str.length) == str && (this.substr(str.length, 1) == "" || this.substr(str.length, 1) == "_" )) {
        return true;
    } else {
        return false;
    }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./yp/index.js